import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundClockwise32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowRoundClockwise32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M22.71 14c-1.094-3.695-4.771-5.766-8.521-4.761-3.813 1.021-5.972 4.76-4.95 8.573s4.76 5.971 8.573 4.95a7.3 7.3 0 0 0 2.806-1.433c.299-.25.516-.474.653-.63a4 4 0 0 0 .178-.22 1 1 0 0 1 1.647 1.135l-.825-.565.825.566-.002.002-.003.004-.006.01-.02.027-.064.085q-.08.107-.228.276a8 8 0 0 1-.875.847 9.3 9.3 0 0 1-3.568 1.828C13.45 26 8.615 23.21 7.307 18.33s1.484-9.715 6.364-11.023c4.237-1.135 8.439.819 10.33 4.546V9.5a1 1 0 1 1 2 0V16h-6.5a1 1 0 1 1 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundClockwise32);
